<template>
  <aside class="refinements">
    <div class="refinements__title-wrapper">
      <h5 class="refinements__title">Refine Results</h5>
    </div>
    <div
      v-for="(facet, i) in filteredFacets"
      :key="`search-facets-${i}`"
      class="refinements__wrapper"
    >
      <div @click="toggleRefinement(facet)" class="refinements__parent">
        <span class="refinements__highlight"></span>
        <span class="refinements__key">{{ facet.title }}</span>
      </div>
      <ais-refinement-list
        v-show="!hiddenRefinements.includes(facet)"
        :attribute="facet.facet"
        :limit="5"
        :show-more="true"
        :show-more-limit="20"
        :class-names="{
          'ais-RefinementList-list': 'refinements__list',
          'ais-RefinementList-item': 'refinements__item',
          'ais-RefinementList-label': 'refinements__label',
          'ais-RefinementList-labelText': 'refinements__label-text',
          'ais-RefinementList-count': 'refinements__count',
          'ais-RefinementList-checkbox': 'refinements__checkbox',
          'ais-RefinementList-showMore': 'refinements__more-btn',
          'ais-RefinementList-showMore--disabled':
            'refinements__more-btn-disabled',
        }"
      ></ais-refinement-list>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Refinements',
  data() {
    return {
      hiddenRefinements: [],
    }
  },
  props: {
    facets: {
      type: Array,
      required: true,
    },
    customFacet: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      isFiltersCollapsed: 'search/isFiltersCollapsed',
    }),
    filteredFacets() {
      let filteredFacets = this.facets
      if (this.customFacet && this.customFacet.type) {
        filteredFacets = filteredFacets.filter(
          facet => facet.facet !== this.customFacet.type
        )
      }
      return filteredFacets
    },
  },
  watch: {
    isFiltersCollapsed(isFiltersCollapsed) {
      if (isFiltersCollapsed) {
        this.collapseFilters(isFiltersCollapsed)
      }
    },
  },
  methods: {
    toggleRefinement(facet) {
      if (this.hiddenRefinements.includes(facet)) {
        this.hiddenRefinements = this.hiddenRefinements.filter(
          refinement => refinement !== facet
        )
      } else {
        this.hiddenRefinements.push(facet)
      }
    },
    collapseFilters(e) {
      if (e) {
        this.filteredFacets.map(facet => {
          this.hiddenRefinements.push(facet)
        })
      } else {
        this.hiddenRefinements = []
      }
    },
  },
}
</script>

<style lang="scss">
.refinements {
  $this: &;
  @include tablet {
    padding: 0 15px 0 0;
    margin: 0;
  }
  margin: 0 0 20px 0;
  &__title-wrapper {
    display: flex;
  }
  &__title {
    color: var(--white);
    width: 100%;
    margin: 0 0 20px 0;
    font-size: 1rem;
    text-transform: uppercase;
  }
  &__list {
    border-radius: 10px;
    margin: 0;
    padding: 0 0 0 5px;
    animation: fadeIn 1s ease-out;
    width: 100%;
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
  &__item {
    width: 100%;
    border-bottom: 1px solid #323232;
    color: var(--white);
    list-style: none;
    text-transform: capitalize;
    transition: 0.5s all ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    font-size: 1rem;
    &:hover {
      cursor: pointer;
      color: var(--orange);
    }
  }
  &__label {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
  }
  &__label-text {
    font-size: 1rem;
    margin: 0 0 0 10px;
  }
  &__count {
    font-size: 1rem;
    margin-left: auto;
    border-radius: 25px;
  }
  &__checkbox {
    margin: 0 5px;
    appearance: none;
    background: var(--flat-black);
    color: var(--white);
    padding: 10px;
    &:hover {
      cursor: pointer;
    }
    &:checked {
      background: var(--orange);
      color: var(--white);
      position: relative;
      display: inline-block;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      transform: rotate(45deg);
      &::before {
        content: '';
        position: absolute;
        width: 3px;
        height: 9px;
        background-color: var(--white);
        left: 11px;
        top: 6px;
      }
      &::after {
        content: '';
        position: absolute;
        width: 3px;
        height: 3px;
        background-color: var(--white);
        left: 8px;
        top: 12px;
      }
    }
  }
  &__more-btn {
    background: transparent;
    color: var(--white);
    margin: 20px auto 50px auto;
    text-align: center;
    width: auto;
    border: none;
    background: var(--light-gray);
    border-radius: 25px;
    cursor: pointer;
    transition: 0.5s all ease;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    font-size: 0.8rem;
    padding: 5px 15px;
    &:hover {
      opacity: 0.8;
    }
  }
  &__more-btn-disabled {
    display: none;
  }
  &__parent {
    margin: 0 0 10px 0;
    text-transform: uppercase;
    background-color: var(--light-gray);
    display: flex;
    align-items: center;
    padding: 15px 0px;
    &:hover {
      cursor: pointer;
      #{$this}__highlight {
        background-color: var(--white);
      }
      #{$this}__key:after {
        background: var(--orange);
      }
    }
  }
  &__highlight {
    width: 6px;
    height: 27px;
    background-color: var(--orange);
    vertical-align: middle;
    transition: 0.5s all ease;
  }
  &__key {
    text-transform: capitalize;
    color: var(--white);
    transition: 0.5s all ease;
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0 0 0 15px;
    width: 90%;
    display: flex;
    align-items: center;
    &:after {
      content: '';
      display: block;
      background: var(--white);
      width: 15px;
      height: 3px;
      margin: 0 0 0 auto;
      transition: 0.5s all ease;
    }
  }
}
</style>
